<template>
    <div class="p-3">
        delivery receipts
    </div>
</template>

<script>
export default {
    name: "DeliveryReceipts",
    components: {},
    props: {},
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    computed: {},
    filters: {},
    watch: {}
}
</script>

<style scoped>

</style>
